
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {MetricAggregated} from "@/cube/metric-data"

@Component({components: {ChangeRateWidget}})
export default class SuperScoreComponentWidget extends Vue {
  @Prop() metricData: MetricAggregated
  @Prop() name: string
  @Prop() icon: string
  @Prop() message: string
  @Prop() to: string

  get isShowAttention() {
    return this.metricData.end
      ? this.metricData.end.amountPercent > 0.45
      : false
  }

  get amount() {
    return this.metricData.end?.amount
  }

  get amountPercent() {
    return this.metricData.end?.amountPercent
  }

  navigate() {
    // For ripple effect
    setTimeout(async () => this.$router.push(this.to), 100)
  }
}
